import { gql } from "@apollo/client";

export const GET_DASHBOARD = gql`
  query ($from: String!, $to: String!, $charts: String!, $target: Int!) {
    dashboard(from: $from, to: $to, charts: $charts, target: $target)
  }
`;
